import type { Socket } from "socket.io-client";
import type {
  ServerToClientEvents,
  ClientToServerEvents,
} from "@amzn/a4k-creator-studio-shared";
import { useConfigStore } from "../configStore";

type TypedSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

export function registerGalleryHandlers(socket: TypedSocket): void {
  socket.on("configUpdated", (data) => {
    if (data.imageStyle) useConfigStore.setState({ imageStyle: data.imageStyle });
    if (data.outputFormat) useConfigStore.setState({ outputFormat: data.outputFormat });
  });
}
